<section class="message-from">
  <div class="message-from-wrapper d-flex flex-column flex-md-row justify-content-center align-items-center">
    <div class="row head-info justify-content-center align-items-center flex-direction-column" style="margin-bottom: 270px;">

      <img src="../../../assets/about/lisamccourry.jpg" alt="Lisa McCourry">
      <h2>Message from</h2>
      <h3>Lisa McCourry</h3>
      <h4>CEO, WorldERP™</h4>

    </div>

    <div class="row" style="border: 0px solid;">
      <ul class="president-text" style="margin-left: 30px;">
        <li>
          <p>
            I’m honored to share that I have officially taken on the role of Chief Executive Officer (CEO) of Worlderp, Inc.
            </p>
            <p>
            Worlderp, Inc. is a software company dedicated to developing innovative ERP and business management solutions that help organizations streamline operations and grow smarter.
            </p>
            <p>
            With a background in education and program development through my work with the Maryland State Department of Education, I bring a strong foundation in systems thinking, leadership, and collaboration to this new role. My experience working to support programs that serve diverse communities has shaped my vision for creating technology that is both powerful and accessible.
            </p>
            <p>
            As CEO, I’m committed to leading with purpose, innovation, and integrity as we expand our reach and continue building software that empowers businesses and organizations to thrive.
          </p>
        </li>
        <li>
          <p>On behalf of all of us here at WorldERP™, Inc. - now a WBE-certified (Women Business Enterprise) Small Business,<br /><br /> I would like to welcome you to our website.</p>
        </li>
        <li>
          <p>WorldERP™ is comprised of former government officials, subject matter experts, and some of the most brilliant minds of our time servicing both Public and Private sectors.</p>
        </li>
        <li>
          <p>After more than 20yrs, we continue to uphold the same principles and values that underpin our reputation as a premier software solutions provider and business consulting firm that is second to none.</p>
        </li>
        <li>
          <p>We pride ourselves in serving our country and the world with respect and honor, designing and delivering some of the most innovative and costeffective solutions in the world.</p>
        </li>
        <li>
          <p>…and now we look forward to assisting your firm.</p>
        </li>
      </ul>
    </div>
  </div>

  <div style="margin-top: 50px;"></div>

  <div class="message-from-wrapper d-flex flex-column flex-md-row justify-content-center align-items-center">
    <div class="row head-info justify-content-center align-items-center flex-direction-column">

      <img src="../../../assets/about/CEO_Glenn_Transparent.png" alt="Glenn Summerfield">
      <h2 style="display:none;">Message from</h2>
      <h3>Glenn Summerfield</h3>
      <h3>1965-2025</h3>
      <h4>Founder & President, WorldERP™</h4>

    </div>

    <div class="row" style="border: 0px solid;">
      <ul class="president-text">
        <li>
          <p>Mr. Glenn Summerfield had over 30 years of management, efficiency analysis, design, development and marketing experience with several Fortune 500 firms as well as Federal, State, Local, and Foreign Government Agencies. His experience as a Scientist and former U.S. Diplomat provided him with invaluable troubleshooting and negotiating skills.</p>
          <p>He held a Bachelor's degree in nuclear engineering and electronic engineering with an Associate's degree in computer science.</p>
          <p>Following his desire to help organizations manage their internal financial processes especially in the area of  procurement and spend management Mr. Glenn Summerfield founded WorldERP back in 2005 to apply his knowledge and extensive expertise to help organizations be effective and succeed.</p>

          <p>At present WorldERP continues to uphold high standards of technical excellence and business integrity layed down by our Founder and President, Mr. Glenn Summerfield.  </p>

        </li>        
      </ul>
    </div>
  </div>
</section>
